/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_ExceedsInputs */

const en_adm_err_exceeds = /** @type {(inputs: Adm_Err_ExceedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can only hand out permissions you have yourself.`)
};

const de_adm_err_exceeds = /** @type {(inputs: Adm_Err_ExceedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst nur Berechtigungen vergeben, die du selbst hast.`)
};

/**
* | output |
* | --- |
* | "You can only hand out permissions you have yourself." |
*
* @param {Adm_Err_ExceedsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_exceeds = /** @type {((inputs?: Adm_Err_ExceedsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_ExceedsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_exceeds(inputs)
	return en_adm_err_exceeds(inputs)
});